import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUp } from "lucide-react";

export default function BackToTop() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.25, ease: [0.22, 0.61, 0.36, 1] }}
          onClick={scrollToTop}
          aria-label="Back to top"
          data-testid="back-to-top"
          className="fixed bottom-8 right-8 z-50 w-12 h-12 flex items-center justify-center bg-[#000000] text-[var(--crest-gold)] border border-[var(--crest-gold)]/40 hover:bg-[var(--crest-gold)] hover:text-[#000000] hover:border-[var(--crest-gold)] transition-colors shadow-[0_8px_24px_rgba(0,0,0,0.25)]"
        >
          <ArrowUp size={18} strokeWidth={1.5} />
        </motion.button>
      )}
    </AnimatePresence>
  );
}
